module.exports = __webpack_public_path__ + "07d2b1ed2aa93592afc9fb24521267d2.svg";